
import { mapState, mapGetters, mapActions } from 'vuex';
import LikeScore from '@/enums/LikeScore';
import TransitionFadeHeight from '@/transitions/TransitionFadeHeight';

export default {
  name: 'AppReviewLikeSection',
  components: { TransitionFadeHeight },
  props: {
    review: {
      type: Object,
      required: true
    },
    showSpamReportButton: { type: Boolean, default: true }
  },
  data() {
    return {
      isCommentsExpanded: false
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapState('like', ['isLoadingLike']),
    ...mapGetters('session', ['isLoggedIn']),
    ...mapGetters('like', ['currentPlusLikesCount', 'currentMinusLikesCount']),
    liked() {
      return this.currentLikeScore === LikeScore.LIKE;
    },
    unliked() {
      return this.currentLikeScore === LikeScore.UNLIKE;
    },
    currentLikeScore() {
      return this.review.like_score;
    }
  },
  watch: {
    review(newReview, oldReview) {
      if (newReview.id === oldReview.id) return;

      this.resetIsCommentsExpanded();
    }
  },
  created() {
    this.resetIsCommentsExpanded();
  },
  methods: {
    ...mapActions('widget', ['confirmForLogin']),
    ...mapActions('comment', ['fetchComments']),
    ...mapActions('like', ['createLike', 'deleteLike']),
    onClickLike() {
      if (this.liked) this.cancelLike();
      else this.postLike(LikeScore.LIKE);
    },
    onClickUnlike() {
      if (this.unliked) this.cancelLike();
      else this.postLike(LikeScore.UNLIKE);
    },
    postLike(score) {
      if (this.isLoadingLike) return;
      if (!this.isLoggedIn) {
        this.confirmForLogin();
        return;
      }

      this.createLike({ reviewId: this.review.id, score }).catch(() =>
        this.windowService.alert(this.$t('already_submitted'))
      );
    },
    cancelLike() {
      if (this.isLoadingLike) return;
      if (!this.isLoggedIn) {
        this.confirmForLogin();
        return;
      }

      this.deleteLike({ reviewId: this.review.id });
    },
    onClickCommentsInfo() {
      if (this.review.comments === undefined) {
        this.fetchComments({
          reviewId: this.review.id
        }).then(() => (this.isCommentsExpanded = true));
        return;
      }

      this.isCommentsExpanded = !this.isCommentsExpanded;
    },
    resetIsCommentsExpanded() {
      this.isCommentsExpanded = this.reviewSettings.always_show_comments;
    }
  }
};
